import React, { ErrorInfo, ReactPropTypes } from 'react';
import { Button, Dialog } from 'shamrock-clover-ui';
import FirebaseAnalytics from '../core/analytics';
import {getDeviceType} from '../../utils/utils';

export default class ErrorBoundary extends React.Component<React.PropsWithChildren<Partial<ReactPropTypes>>> {
  state: { error: Error; errorInfo: ErrorInfo; showModal: boolean };
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, showModal: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const {width, height} = window.screen;
    const moduleMatch = /webpack\/container\/reference\/([a-z]*)/gm;
    const [, moduleName] = moduleMatch.exec(String(error));
    const moduleKey = Object.keys(FirebaseAnalytics.MODULES)
      .find((k) => FirebaseAnalytics.MODULES[k].toLowerCase() === moduleName);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    FirebaseAnalytics.sendEvent(
      FirebaseAnalytics.EVENTS.PAGE_VIEW,
      FirebaseAnalytics.MODULES[moduleKey],
      FirebaseAnalytics.PAGES.HOME_PAGE,
      {
        label: FirebaseAnalytics.LABELS.ERROR,
        resolution: `${width}X${height}`,
        browserType: getDeviceType(),
      },
    );
  }

  modalButtons() {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '100px',
        justifyContent: 'space-between',
      }}>
        <div>
          <Button
            variant="outlined"
            color="blue"
            height="50px"
            width="140px"
            onClick={(): void => {
              this.setState({ showModal: false});
            }}
          >
            CANCEL
          </Button>
        </div>
        <div>
          <Button
            color="blue"
            height="50px"
            width="140px"
            onClick={(): void => {
              window.location.reload();
            }}
          >
            TRY AGAIN
          </Button>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.errorInfo) {
      return (
        <div
          style={{
            display: 'flex',
            width: '100vw',
            height: '100vh',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '10%',
          }}
        >
          <h1 style={{ color: '#666666', display: 'none' }}>Something went wrong.</h1>
          <div style={{ width: 500, display: 'none' }}>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </details>
          </div>
          <Dialog
            open={this.state.showModal}
            actions={this.modalButtons()}
            onClose={() => this.setState({showModal: false})}
            title='There seems to be a connection issue.'
            content='Loading of this service is taking longer than expected. Please try again in a minute.
            If this problem persists, call us at (888) 874-7053.'
            width='450px'
          />
        </div>
      );
    }
    return this.props.children;
  }
}
